import { baseStyle, colors } from '../../shared/styles/baseStyle';

export const button = {
  ...baseStyle.button,
  marginTop: 30,
  backgroundColor: 'black'
};
export const cancelButton = {
  ...baseStyle.button,
  backgroundColor: colors.anytimeBlue,
  marginTop: 5
};
export const disabledButton = {
  ...baseStyle.button,
  marginTop: 30,
  backgroundColor: colors.disabledGrey
};
export const linkButton = { marginLeft: -12, marginRight: -12, marginTop: -5 };
export const row = { marginTop: 15 };
export const img = {
  marginBottom: 10
};
export const portalButton = { ...linkButton, marginRight: -10 };
